import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { ColumnDefinition } from '@publicisgroupe/p-os-components';
import { ThemeDetails } from 'interfaces/ThemeDetails';

const DATE_FORMAT = 'dd MMM yyyy';

export const ThemeLibraryColumnDefinitions = (): ColumnDefinition<ThemeDetails, any, any>[] => {
  const { t } = useTranslation();

  return [
    {
      name: t('Client'),
      accessor: 'Client',
      selector: (x: ThemeDetails) => x.client,
      cell: (theme: ThemeDetails) => theme.client,
      sortable: true,
    },
    {
      name: t('CreatedOn'),
      accessor: 'CreatedAt',
      selector: (theme: ThemeDetails) =>
        theme.createdAt ? format(new Date(theme.createdAt), DATE_FORMAT) : '',
      cell: (theme: ThemeDetails) =>
        theme.createdAt ? format(new Date(theme.createdAt), DATE_FORMAT) : '',
      sortable: true,
    },
    {
      name: t('CreatedBy'),
      accessor: 'CreatedBy',
      selector: (theme: ThemeDetails) => theme.createdBy,
      cell: (theme: ThemeDetails) => theme.createdBy,
      sortable: true,
    },
    {
      name: t('UpdatedOn'),
      accessor: 'UpdatedAt',
      selector: (theme: ThemeDetails) =>
        theme.updatedAt ? format(new Date(theme.updatedAt), DATE_FORMAT) : '',
      cell: (theme: ThemeDetails) =>
        theme.updatedAt ? format(new Date(theme.updatedAt), DATE_FORMAT) : '',
      sortable: true,
    },
    {
      name: t('UpdatedBy'),
      accessor: 'UpdatedBy',
      selector: (theme: ThemeDetails) => theme.updatedBy,
      cell: (theme: ThemeDetails) => theme.updatedBy,
      sortable: true,
    },
  ];
};
